export function pagination() {
  if (!document.querySelector('#pagination')) {
    return;
  }

  import(
    /* webpackChunkName: "proposal-offers-app" */ './components/paginator/main'
  );
}
